'use client'

import { ReactNode } from 'react'
import { cn } from '~/lib/utils'

export default function OverviewStatusRow({
  objective,
  time,
  className,
}: {
  objective: ReactNode
  time: ReactNode
  className?: string
}) {
  return (
    <div className={cn('flex w-full flex-nowrap items-center gap-0.5 pr-1', className)}>
      <div className="w-[5.5rem] min-w-0 shrink-0 empty:hidden">{objective}</div>
      <div className="w-[5.5rem] min-w-0 shrink-0 sm:ml-auto">{time}</div>
    </div>
  )
}
